import { render, staticRenderFns } from "./AccountingInformations.vue?vue&type=template&id=3dc2564b&"
import script from "./AccountingInformations.vue?vue&type=script&lang=js&"
export * from "./AccountingInformations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports